import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const OurTeamsPageSession = React.lazy(() => import('../teams/OurTeamsPageSession'));
const OurTeamsPageHeader = React.lazy(() => import('../teams/OurTeamsPageHeader'));

function OurTeamPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />}>
       <OurTeamsPageHeader />
       <OurTeamsPageSession />
      </Suspense>
    </div>
  );
}

export default OurTeamPage;
